import SettingContainer from "./setting.container";

export default SettingContainer;
